import { render, staticRenderFns } from "./Live.vue?vue&type=template&id=d10a3f3c"
import script from "./Live.vue?vue&type=script&lang=js"
export * from "./Live.vue?vue&type=script&lang=js"
import style0 from "./Live.vue?vue&type=style&index=0&id=d10a3f3c&prod&lang=css"
import style1 from "./Live.vue?vue&type=style&index=1&id=d10a3f3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports